import { useStore } from 'vuex';
import { computed, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';

const useCheck = ({ itemId = '', listItemId = [], listAnnouncements = [] }) => {
	const route = useRoute();
	const store = useStore();
	const listToTrash = computed(() => store.state.announcements.listToTrash);
	const isAllChecked = computed(() => store.state.announcements.isAllChecked);
	const isChecked = ref(listToTrash.value.includes(itemId.value));
	const isForcedReset = computed(() => store.state.announcements.isForcedReset);

	const handlerClickCheck = () => {
		if (isAllChecked.value) {
			store.commit('announcements/changeIsResetAllChecked', true);
			store.commit('announcements/changeAllChecked', false);
		}

		isChecked.value = !isChecked.value;

		if (isChecked.value) {
			store.commit('announcements/addItemToListTrash', itemId.value);
			const allSelected = listAnnouncements.length === listToTrash.value.length;

			if (allSelected) {
				store.commit('announcements/changeAllChecked', true);
			}

			return;
		}

		store.commit('announcements/removeItemToListTrash', itemId.value);
	};

	const changeAllCheck = () => {
		store.commit('announcements/changeIsResetAllChecked', false);
		store.commit('announcements/changeAllChecked', !isAllChecked.value);

		if (isAllChecked.value) {
			store.commit('announcements/addAllItemToListTrash', listItemId.value);
			return;
		}

		store.commit('announcements/removeAllItemToListTrash');
	};

	const handlerClickAllCheck = () => {
		changeAllCheck();
	};

	watch(() => isAllChecked.value, () => {
		if (!isForcedReset.value) {
			isChecked.value = isAllChecked.value;
		}
	});

	watch(() => route.query.tab, () => {
		if (!isAllChecked.value) {
			isChecked.value = isAllChecked.value;
		}

		store.commit('announcements/resetState');
	});

	onMounted(() => {
		store.commit('announcements/changeAllChecked', false);
	});

	return {
		isAllChecked,
		isChecked,
		handlerClickCheck,
		handlerClickAllCheck,
	};
};

export default useCheck;
